import batchApi from "js/utils/batchApi.js";
import { fetchBatchPhotoCounts, fetchUploadIds } from "./clientApi";

/**
 * getBatchPhotoCounts
 * Reduce API Calls: Only fetches when Batch currentPage > 1, otherwise should be the same?
 * @param {Array} batchIds Array of Batch Ids only
 * @param {Boolean} showOnlySuspendedCreators
 * @returns array of Batch Photo Counts
 */
export const getBatchPhotoCounts = async (
    batchIds,
    showOnlySuspendedCreators
) => {
    try {
        const batches = batchApi.convertArrayToBatches(batchIds, 50);
        const responses = await batchApi.calls(batches, async batch => {
            return await fetchBatchPhotoCounts(
                batch,
                showOnlySuspendedCreators
            );
        });
        return batchApi.mergeArrays(responses);
    } catch (error) {
        const errorMessage = `getBatchPhotoCounts: Error: ${error}`;
        console.error(errorMessage, { batchIds, showOnlySuspendedCreators });
        throw error;
    }
};

/**
 * getUploadIds
 * @param {Array} batchIds
 * @returns {Array} uploadIds
 */
export const getUploadIds = async (batchIds = []) => {
    try {
        const batches = batchApi.convertArrayToBatches(batchIds, 50);
        const responses = await batchApi.calls(batches, async batch => {
            return await fetchUploadIds(batch);
        });
        return batchApi.mergeArrays(responses);
    } catch (error) {
        const errorMessage = `getUploadIds: Error: ${error}`;
        console.error(errorMessage, { batchIds });
        throw error;
    }
};
